import { render, staticRenderFns } from "./AdminJdrs.vue?vue&type=template&id=f5004f68&scoped=true"
import script from "./AdminJdrs.vue?vue&type=script&lang=js"
export * from "./AdminJdrs.vue?vue&type=script&lang=js"
import style0 from "./AdminJdrs.vue?vue&type=style&index=0&id=f5004f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5004f68",
  null
  
)

export default component.exports